import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly apiUrl = `${environment.apiUrl}/users`;

  constructor(private http: HttpClient) {}

  getUsers(search = '', page = 0, size = 10, sort = 'username,asc'): Observable<{content: User[], totalElements: number, totalPages: number}> {
    const params = new URLSearchParams({ search, page: String(page), size: String(size), sort });
    return this.http.get<{content: User[], totalElements: number, totalPages: number}>(`${this.apiUrl}?${params.toString()}`);
  }

  getUserById(id: number): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/${id}`);
  }

  createUser(user: User): Observable<any> {
    return this.http.post(this.apiUrl, user);
  }

  updateUser(id: number, user: User): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, user);
  }
}
